/**
 * Port of timeRangePicker.service.js from the portal/ui app
 *
 */

/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */

import { compact, findLast, isEmpty } from 'lodash';

import { timeRangeFormatter } from '../../../../utilities';
import { getTimesOffset } from '../../data-series';

const SELECTION_LABEL_X_MARGIN = 40;
const maxPointerWidth = 60;

export function getLabelPositionAgainstChart(times, chartWidth, labelWidth, pointWidth, selectedTime) {
    const pixels = getTimesOffset(times, selectedTime, pointWidth);
    let labelX = pixels - labelWidth / 2 + pointWidth / 2;
    labelX = Math.max(labelX, 0);
    labelX = Math.min(labelX, chartWidth - labelWidth);
    return labelX;
}

export function findSelectedPoints(chart, selectedTime) {
    if (!chart) {
        return [];
    }
    return compact(
        chart.series.map((series) => {
            return findLast(series.points, (point) => point?.options?.pointData?.date <= selectedTime);
        })
    );
}

export function initSelectionIndicator(chart, pointWidth) {
    const renderer = chart.renderer;
    const pointerWidth = Math.min(maxPointerWidth, pointWidth);
    const pointerHeight = Math.min(pointerWidth * 0.33, (chart.chartHeight - chart.plotHeight - chart.plotTop) * 0.5);

    const selectionIndicator = renderer.g('selection-indicator-group');
    selectionIndicator.pointWidth = pointWidth;
    selectionIndicator.addClass('hidden');

    const frameElement = renderer.path([
        'M',
        0,
        0,
        0,
        chart.plotHeight,
        pointWidth / 2 - pointerWidth / 2,
        chart.plotHeight,
        pointWidth / 2,
        chart.plotHeight + pointerHeight,
        pointWidth / 2 + pointerWidth / 2,
        chart.plotHeight,
        pointWidth,
        chart.plotHeight,
        pointWidth,
        0,
        'z',
    ]);
    frameElement.addClass('selection-indicator-frame');
    frameElement.add(selectionIndicator);

    selectionIndicator.pointerElement = renderer.path([
        'M',
        0,
        chart.plotHeight,
        pointWidth / 2 - pointerWidth / 2,
        chart.plotHeight,
        pointWidth / 2,
        chart.plotHeight + pointerHeight,
        pointWidth / 2 + pointerWidth / 2,
        chart.plotHeight,
        pointWidth,
        chart.plotHeight,
        'z',
    ]);
    selectionIndicator.pointerElement.addClass('selection-indicator-pointer');
    selectionIndicator.pointerElement.translate(0, -1);
    selectionIndicator.pointerElement.add(selectionIndicator);

    selectionIndicator.add(renderer.boxWrapper);

    return selectionIndicator;
}

export const timeGranularityFormatter = (start, granularity) => timeRangeFormatter({ start, end: start + granularity });

export function initSelectionLabel(chart, start, granularity) {
    const renderer = chart.renderer;

    const selectionLabel = renderer.text(timeGranularityFormatter(start, granularity));
    selectionLabel.addClass('selection-indicator-label');
    selectionLabel.add(renderer.boxWrapper);

    return selectionLabel;
}

export function isXCoordinateWithinSelectionLabel(
    x,
    selectionLabel,
    chart,
    selectedTime,
    times,
    chartWidth,
    pointWidth
) {
    if (!selectionLabel || isEmpty(selectionLabel)) return false;

    const points = findSelectedPoints(chart, selectedTime);

    if (points.length === 0) return false;

    const labelBBox = selectionLabel.element.getBBox();
    const labelX = getLabelPositionAgainstChart(times, chartWidth, labelBBox.width, pointWidth, selectedTime);
    const leftLimit = labelX - SELECTION_LABEL_X_MARGIN;
    const rightLimit = labelX + labelBBox.width + SELECTION_LABEL_X_MARGIN;

    return x >= leftLimit && x <= rightLimit;
}
